"use strict";

var _interopRequireWildcard = require("/Volumes/Untitled/project/050/050store/node_modules/@babel/runtime/helpers/interopRequireWildcard.js");
var _interopRequireDefault = require("/Volumes/Untitled/project/050/050store/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regeneratorRuntime2 = _interopRequireDefault(require("/Volumes/Untitled/project/050/050store/node_modules/@babel/runtime-corejs2/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/Volumes/Untitled/project/050/050store/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var api = _interopRequireWildcard(require("@/api/menu-food"));
var state = {
  list: []
};
var mutations = {
  setList: function setList(state, val) {
    state.list = val;
  }
};
var actions = {
  fetchList: function () {
    var _fetchList = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee(_ref, payload) {
      var commit, res;
      return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            commit = _ref.commit;
            _context.next = 3;
            return api.findAll(payload);
          case 3:
            res = _context.sent;
            commit("setList", res.data.menuFoods);
            return _context.abrupt("return", res.data.total);
          case 6:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    function fetchList(_x, _x2) {
      return _fetchList.apply(this, arguments);
    }
    return fetchList;
  }()
};
var _default = exports.default = {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};